class CustomCollectionSwitcher extends HTMLElement {
  constructor() {
    super();
    this.slides = [];
    this.isMobile = window.innerWidth <= 768;
  }

  connectedCallback() {
    this.container = this.querySelector(".collection-display-area");
    this.tabs = this.querySelectorAll(".custom-tab-link");
    this.loadSlides();

    if (this.slides.length > 0) {
      this.activateSlide(this.slides[0].dataset.handle);
    }

    this.tabs.forEach((tab) => {
      tab.addEventListener(this.isMobile ? "click" : "mouseenter", (e) => {
        e.preventDefault();
        const handle = tab.dataset.handle;
        this.activateSlide(handle);

        if (!this.isMobile) {
          tab.addEventListener("click", () => {
            window.location.href = `/collections/${handle}`;
          });
        }
      });
    });

    this.applyDesktopPadding();
    window.addEventListener("resize", () => this.applyDesktopPadding());
  }

  loadSlides() {
    this.slides = Array.from(this.querySelectorAll(".collection-slide-item"));
    this.slides.forEach((slide, index) => {
      const caption = slide.dataset.caption;
      const captionElem = document.createElement("div");
      captionElem.classList.add("collection-caption-area");
      captionElem.innerHTML = `<h3>${caption}</h3>`;
      slide.appendChild(captionElem);

      if (index === 0) {
        slide.classList.add("active");
        captionElem.classList.add("fade-in");
      } else {
        slide.classList.remove("active");
      }
    });
  }

  activateSlide(handle) {
    this.slides.forEach((slide) => {
      const caption = slide.querySelector(".collection-caption-area");

      if (slide.dataset.handle === handle) {
        slide.classList.add("active");
        caption?.classList.add("fade-in");
      } else {
        slide.classList.remove("active");
        caption?.classList.remove("fade-in");
      }
    });

    this.tabs.forEach((tab) => {
      tab.classList.toggle("active", tab.dataset.handle === handle);
    });
  }

  applyDesktopPadding() {
    const isDesktop = window.innerWidth > 768;
    if (isDesktop) {
      this.style.paddingTop = this.dataset.desktopPaddingTop + "px";
      this.style.paddingBottom = this.dataset.desktopPaddingBottom + "px";
    }
  }
}

customElements.define("custom-collection-switcher", CustomCollectionSwitcher);
